var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sum-list"},[_c('ul',{staticClass:"counts-list"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"item"},[_c('p',[_vm._v(_vm._s(item.title))]),_c('p',[_vm._v(_vm._s(item.value))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }